import { Configuration, PopupRequest } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || 'YOUR-CLIENT-ID',
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID || 'YOUR-TENANT-ID'}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest: PopupRequest = {
  scopes: ['openid', 'profile', 'email'],
};

export const isAzureAdConfigured =
  process.env.REACT_APP_AZURE_CLIENT_ID !== undefined &&
  process.env.REACT_APP_AZURE_CLIENT_ID !== 'YOUR-CLIENT-ID' &&
  process.env.REACT_APP_AZURE_TENANT_ID !== undefined &&
  process.env.REACT_APP_AZURE_TENANT_ID !== 'YOUR-TENANT-ID';
